// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_RefundsSummaryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payroll/refunds_summary/{periodId}
 *
 * Dados shape: Summary of refunds by user for a period.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_RefundsSummaryResponseDados {
summary_by_user: unknown[]
total_refunds: number
count: number
}

export type Payroll_RefundsSummaryResponse = ApiResponse<Payroll_RefundsSummaryResponseDados>;

registerResponseContract('Payroll_RefundsSummaryResponse', {
  summary_by_user: { type: 'array',   required: true },
  total_refunds:   { type: 'number',  required: true },
  count:           { type: 'number',  required: true },
})
